import { classNames } from "primereact/utils";
import styles from "./TimeDurationField.module.scss";
import { Controller, useFormContext } from "react-hook-form";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { useAppContext } from "../../../../../AppContext";
import { AppTooltip } from "../../../tooltip/AppTooltip";
import { Calendar } from "primereact/calendar";
import { Icon, IconType } from "../../../../icons/Icon";
import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

interface ITimeDurationFieldProps {
  className?: string;
  name: string;
  tooltip?: string;
  label?: string;
  required?: boolean;
  width?: string;
  minWidth?: string;
  disabled?: boolean;
  placeholder?: string;
}

export const TimeDurationField = ({
  className,
  name,
  tooltip,
  label,
  required = false,
  width,
  minWidth,
  disabled,
  placeholder = "Въведете продължителност",
}: ITimeDurationFieldProps) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }

  const minutesToTimeDate = (minutes: number): Date | null => {
    if (!minutes || minutes <= 0) return null;

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(mins);
    date.setSeconds(0);
    return date;
  };

  const timeDateToMinutes = (date: Date | null): number => {
    if (!date) return 0;
    return date.getHours() * 60 + date.getMinutes();
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const timeValue = minutesToTimeDate(field.value);

        const handleTimeChange = (e: any) => {
          const minutes = timeDateToMinutes(e.value);
          field.onChange(minutes);
        };

        return (
          <div
            style={{ width: width, minWidth: minWidth, maxWidth: width }}
            className={classNames(className, styles.root, {
              [styles.root_disabled]: disabled,
            })}
          >
            <RenderWhen condition={!!label}>
              <div
                className={classNames(styles.root_label, {
                  [styles.root_label_interacted_with]: !!field.value,
                  [styles.root_label_error]: !!fieldState.error?.message,
                })}
              >
                {label}
                {required ? "*" : ""}
                <AppTooltip content={tooltip} />
              </div>
            </RenderWhen>

            <div className={styles.root_input_container}>
              <Calendar
                id={`${field.name}_picker`}
                value={timeValue}
                onChange={handleTimeChange}
                timeOnly
                showIcon
                className={styles.root_time_picker}
                disabled={disabled}
                icon={<Icon type={IconType.ClockIcon} color="currentColor" />}
                stepMinute={15}
                hourFormat="24"
                touchUI
                hideOnRangeSelection={false}
                showTime
                placeholder={placeholder}
              />
            </div>
          </div>
        );
      }}
    />
  );
};
